import { RouteConfig } from 'routes/routes';

import MapPage from 'pages/map/map';

import { MAP_ROUTE } from './list';

export const mapRoutes: RouteConfig[] = [
  {
    path: MAP_ROUTE,
    element: <MapPage />,
    roles: [],
    permissions: {},
  },
];
